// TYPE ELITE — Extended Font Database (250+ named fonts).
// Only fonts also in fontMap.js render with live Google Font preview.
// The rest are listed as legal named prompt inspiration / user-owned reference (per spec).
const preview = (family) => ({ family, previewCss: family && `"${family}"` });

const F = (name, family, classification, mood, keywords, embed = false) => ({
  name, family, classification, mood, keywords, embed,
});

export const FONT_DATABASE = [
  // ---- Sans Serif (40+)
  F('Anton','Sans Serif','Condensed','bold, headline','condensed bold poster',true),
  F('Oswald','Sans Serif','Condensed','sports, editorial','condensed sports',true),
  F('Poppins','Sans Serif','Geometric','clean, modern','geometric clean',true),
  F('Montserrat','Sans Serif','Geometric','friendly, versatile','geometric urban',true),
  F('Bebas Neue','Sans Serif','Athletic Block','bold, athletic','block sports',true),
  F('League Spartan','Sans Serif','Geometric','strong, modern','geometric bold'),
  F('League Gothic','Sans Serif','Condensed','tall, editorial','condensed tall'),
  F('Archivo Black','Sans Serif','Grotesque','heavy, headline','black grotesque'),
  F('Barlow Condensed','Sans Serif','Condensed','athletic, editorial','condensed athletic',true),
  F('Roboto Condensed','Sans Serif','Condensed','clean, utility','condensed utility'),
  F('Open Sans','Sans Serif','Humanist','friendly, readable','humanist body'),
  F('Raleway','Sans Serif','Elegant Sans','elegant, thin','thin elegant'),
  F('DM Sans','Sans Serif','Geometric','modern, minimal','minimal modern'),
  F('Lexend','Sans Serif','Humanist','readable, accessible','readable clean'),
  F('Futura','Sans Serif','Geometric','vintage, iconic','geometric vintage'),
  F('Lemon Milk','Sans Serif','Futuristic Sans','clean, tech','tech modern'),
  F('Akira Expanded','Display Sans','Extended','bold, cinematic','wide extended cinematic'),
  F('Manrope','Sans Serif','Neo-Grotesque','modern, minimal','modern grotesque',true),
  F('Nunito Sans','Sans Serif','Humanist Rounded','friendly, warm','rounded humanist',true),
  F('Space Grotesk','Sans Serif','Grotesque','tech, futuristic','tech grotesque',true),
  F('Big Shoulders Display','Sans Serif','Extended','industrial, poster','industrial extended',true),
  F('Fredoka','Sans Serif','Rounded','soft, playful','rounded playful',true),
  F('Orbitron','Sans Serif','Techno','sci-fi, digital','sci-fi digital',true),
  F('Inter','Sans Serif','Neo-Grotesque','clean, modern','clean modern'),
  F('Karla','Sans Serif','Grotesque','modern, editorial','editorial grotesque'),
  F('Work Sans','Sans Serif','Grotesque','clean, workhorse','clean workhorse'),
  F('Rubik','Sans Serif','Rounded','friendly, modern','rounded friendly'),
  F('IBM Plex Sans','Sans Serif','Grotesque','corporate, tech','corporate tech'),
  F('Assistant','Sans Serif','Humanist','clean, warm','warm clean'),
  F('Prompt','Sans Serif','Geometric','modern, urban','urban modern'),
  F('Kanit','Sans Serif','Geometric','urban, modern','urban modern'),
  F('Titillium Web','Sans Serif','Techno','tech, sci-fi','sci-fi tech'),
  F('Exo 2','Sans Serif','Techno','futuristic, tech','futuristic tech'),
  F('Rajdhani','Sans Serif','Condensed Techno','gaming, tech','gaming tech'),
  F('Chakra Petch','Sans Serif','Techno','cyberpunk, gaming','cyberpunk gaming'),
  F('Saira Condensed','Sans Serif','Condensed','sports, modern','sports condensed'),
  F('Yanone Kaffeesatz','Sans Serif','Condensed','cafe, editorial','cafe editorial'),
  F('Josefin Sans','Sans Serif','Geometric','vintage, elegant','vintage elegant'),
  F('Cabin','Sans Serif','Humanist','friendly, modern','modern friendly'),
  F('Quicksand','Sans Serif','Rounded','soft, cute','soft cute'),

  // ---- Serif / Slab (30+)
  F('Playfair Display','Serif','Didone','luxury, editorial','luxury editorial',true),
  F('Cormorant Garamond','Serif','Transitional','elegant, refined','elegant refined',true),
  F('DM Serif Display','Serif','Didone','editorial, headline','editorial headline',true),
  F('Bodoni Moda','Serif','Didone','fashion, luxury','fashion luxury'),
  F('Didot','Serif','Didone','fashion, glam','fashion glam'),
  F('Abril Fatface','Serif','Fat Didone','poster, retro','poster retro'),
  F('Cinzel','Serif','Roman Inscription','luxury, ancient','ancient luxury',true),
  F('Libre Baskerville','Serif','Transitional','editorial, book','editorial book'),
  F('Prata','Serif','Didone','editorial, thin','editorial thin'),
  F('Cooper Black','Slab Serif','Fat Slab','retro, groovy','retro groovy'),
  F('EB Garamond','Serif','Old Style','classical, book','classical book',true),
  F('Merriweather','Serif','Transitional','readable, editorial','editorial readable'),
  F('Lora','Serif','Transitional','readable, warm','warm readable'),
  F('PT Serif','Serif','Transitional','editorial, versatile','editorial versatile'),
  F('Crimson Text','Serif','Old Style','book, classical','classical book'),
  F('Roboto Slab','Slab Serif','Modern Slab','editorial, modern','modern slab',true),
  F('Zilla Slab','Slab Serif','Modern Slab','editorial, tech','tech slab',true),
  F('Bitter','Slab Serif','Modern Slab','editorial, warm','warm slab'),
  F('Josefin Slab','Slab Serif','Geometric Slab','vintage, elegant','vintage elegant'),
  F('Alfa Slab One','Slab Serif','Heavy Slab','poster, bold','poster bold'),
  F('Ultra','Slab Serif','Fat Slab','poster, retro','poster retro',true),
  F('Rye','Display Serif','Western Slab','western, rodeo','western rodeo',true),
  F('Sancreek','Display Serif','Western','western, saloon','saloon western'),
  F('Fjalla One','Sans Serif','Condensed','bold, editorial','condensed bold'),
  F('Vollkorn','Serif','Transitional','readable, book','readable book'),
  F('Ovo','Serif','Old Style','elegant, book','elegant book'),
  F('Fraunces','Serif','Transitional','editorial, elegant','elegant editorial'),
  F('Recoleta','Serif','Contemporary Serif','friendly, editorial','friendly editorial'),
  F('Tenor Sans','Sans Serif','Editorial','elegant, thin','thin elegant'),
  F('Marcellus','Serif','Roman Inscription','luxury, refined','luxury refined'),

  // ---- Script / Calligraphy / Signature / Brush (35+)
  F('Great Vibes','Script','Formal Calligraphy','elegant, wedding','wedding calligraphy',true),
  F('Allura','Script','Formal Calligraphy','wedding, elegant','wedding elegant'),
  F('Alex Brush','Script','Brush','wedding, brush','wedding brush'),
  F('Parisienne','Script','Casual Script','soft, romantic','romantic soft'),
  F('Yellowtail','Script','Brush','retro, brush','retro brush'),
  F('Pacifico','Script','Retro Brush','retro, surf','retro surf',true),
  F('Lobster','Script','Retro Sign Painter','retro, sign','retro sign',true),
  F('Sacramento','Script','Brush','romantic, wedding','romantic wedding',true),
  F('Dancing Script','Script','Casual Script','friendly, casual','casual friendly',true),
  F('Sign Painter','Script','Sign Painter','vintage, sign','vintage sign'),
  F('Cloister','Script','Formal Script','luxury, wedding','wedding luxury'),
  F('Bratsy Script','Script','Casual Signature','signature, boutique','signature boutique'),
  F('Billion Dreams','Script','Casual Signature','soft, boutique','boutique soft'),
  F('Darling Girl Demo','Script','Casual Signature','cute, feminine','cute feminine'),
  F('Winterlady','Script','Elegant Script','elegant, winter','winter elegant'),
  F('Candice','Script','Signature','signature, wedding','wedding signature'),
  F('One Kiss','Script','Brush','romantic, wedding','wedding romantic'),
  F('Homemade Apple','Script','Handwritten Script','handwritten, warm','handwritten warm',true),
  F('Kaushan Script','Script','Brush','bold, brush','bold brush'),
  F('Satisfy','Script','Casual','friendly, casual','casual friendly'),
  F('Cookie','Script','Casual','soft, boutique','soft boutique'),
  F('Great Vibes','Script','Formal','elegant, wedding','elegant wedding'),
  F('Bilbo Swash Caps','Script','Formal','swash, elegant','swash elegant'),
  F('Meddon','Script','Handwritten Calligraphy','handwritten calligraphy','handwritten calligraphy'),
  F('Petit Formal Script','Script','Formal','wedding, formal','wedding formal'),
  F('Rouge Script','Script','Formal','elegant, thin','thin elegant'),
  F('Yesteryear','Script','Retro Script','retro, sign','retro sign'),
  F('Reenie Beanie','Script','Handwritten','cute, casual','cute casual'),
  F('Kalam','Handwritten','Casual Print','handwritten, warm','handwritten warm',true),
  F('Caveat','Handwritten','Casual Script','handwritten, casual','handwritten casual',true),
  F('Shadows Into Light','Handwritten','Casual Print','doodle, cute','doodle cute',true),
  F('Gochi Hand','Handwritten','Crayon','crayon, kids','crayon kids',true),
  F('Amatic SC','Handwritten','Tall Handwritten','tall, cute','tall cute'),
  F('Architects Daughter','Handwritten','Casual Print','handwritten, casual','casual handwritten'),
  F('Indie Flower','Handwritten','Casual Print','friendly, doodle','doodle friendly'),

  // ---- Display / Bubble / Chunky / Y2K / Retro / Groovy (35+)
  F('Luckiest Guy','Display','Chunky Comic','comic, chunky','comic chunky'),
  F('Modak','Display','Bubble','bubble, y2k','bubble y2k'),
  F('Black Ops One','Display','Stencil Sci-Fi','military, tech','military tech'),
  F('Bungee','Display','Chunky','bold, sign','bold sign',true),
  F('Bungee Inline','Display','Varsity Inline','varsity, sports','varsity sports',true),
  F('Bungee Shade','Display','Chunky','3D chunky','3D chunky'),
  F('Graduate','Display','Collegiate','varsity, graduation','varsity graduation'),
  F('Placard Condensed','Display','Condensed Display','condensed poster','condensed poster'),
  F('Yearbook Solid','Display','Athletic Block','yearbook, retro','yearbook retro'),
  F('Rubik Mono One','Display','Y2K','y2k, blocky','y2k blocky',true),
  F('Rubik Puddles','Display','Psychedelic','psychedelic, drip','psychedelic drip',true),
  F('Rubik Wet Paint','Display','Wet Paint','wet paint, drip','wet drip',true),
  F('Rubik Beastly','Display','Chunky','chunky, playful','chunky playful'),
  F('Rubik Bubbles','Display','Bubble','bubble, y2k','bubble y2k'),
  F('Rubik Doodle Shadow','Display','Doodle','doodle, playful','doodle playful'),
  F('Rubik Glitch','Display','Digital Glitch','glitch, cyber','cyber glitch'),
  F('Rubik Iso','Display','Isometric','isometric, 3D','isometric 3D'),
  F('Rubik Marker Hatch','Display','Marker Hatch','marker, doodle','marker doodle'),
  F('Rubik Spray Paint','Display','Graffiti','graffiti, spray','graffiti spray'),
  F('Rubik Vinyl','Display','Retro Vinyl','retro, vinyl','retro vinyl'),
  F('Bangers','Display','Comic','comic, bold','comic bold',true),
  F('Bowlby One','Display','Chunky','chunky, poster','poster chunky'),
  F('Titan One','Display','Bubble','bubble, playful','bubble playful'),
  F('Fugaz One','Display','Chunky','chunky, poster','poster chunky'),
  F('Passion One','Display','Chunky','chunky, poster','poster chunky'),
  F('Righteous','Display','Retro','retro, poster','retro poster'),
  F('Monoton','Display','Retro Striped','retro, striped','retro striped'),
  F('Faster One','Display','Speed','speed, racing','racing speed',true),
  F('Rye','Display','Western','western, saloon','western saloon',true),
  F('Sancreek','Display','Western','western, saloon','western saloon'),
  F('Ewert','Display','Circus','circus, carnival','circus carnival',true),
  F('Special Elite','Typewriter','Distressed Typewriter','vintage typewriter','vintage typewriter',true),
  F('Slackey','Display','Chunky Cartoon','cartoon, chunky','cartoon chunky'),
  F('Bagel Fat One','Display','Fat Chunky','fat chunky playful','chunky playful'),
  F('Bowlby One SC','Display','Chunky','chunky sc','chunky sc'),
  F('Sigmar One','Display','Fat Chunky','chunky poster','chunky poster'),
  F('Original Surfer','Display','Retro Sign','retro surf sign','retro surf'),

  // ---- Groovy / Psychedelic / Y2K
  F('Bungee Spice','Display','Chunky','chunky, poster','poster chunky'),
  F('Honk','Display','Groovy 70s','groovy 70s','groovy 70s'),
  F('Rubik Distressed','Display','Distressed','distressed rough','distressed'),
  F('Codystar','Display','Glitter Marquee','glitter marquee','glitter marquee'),
  F('Faster One','Display','Speed Racing','racing speed','racing'),
  F('Bungee Hairline','Display','Line Sign','line sign','line sign'),

  // ---- Futuristic / Techno / Gaming
  F('Audiowide','Display','Futuristic','tech futuristic','tech futuristic'),
  F('Wallpoet','Display','Retro Tech','retro tech','retro tech'),
  F('Iceberg','Display','Tech','clean tech','clean tech'),
  F('Wire One','Display','Wireframe','wireframe thin','wireframe thin'),
  F('Zen Dots','Display','Pixel Tech','pixel tech','pixel tech'),
  F('Press Start 2P','Display','Pixel','pixel arcade','pixel arcade'),
  F('VT323','Display','Terminal','terminal retro','terminal retro'),
  F('Silkscreen','Display','Pixel','pixel retro','pixel retro'),
  F('Major Mono Display','Display','Techno Mono','techno mono','techno mono'),
  F('Michroma','Display','Futuristic','futuristic wide','futuristic wide'),

  // ---- Graffiti / Streetwear
  F('Permanent Marker','Handwritten','Marker Graffiti','marker graffiti','marker graffiti',true),
  F('Bungee Hairline','Display','Line Sign','line sign','line sign'),
  F('Freckle Face','Display','Doodle','doodle graffiti','doodle graffiti'),
  F('Bungee Inline','Display','Sign','sign inline','sign inline'),
  F('Shadows Into Light Two','Handwritten','Marker','marker shadow','marker shadow'),

  // ---- Horror / Halloween
  F('Creepster','Horror','Dripping','halloween dripping','halloween dripping',true),
  F('Butcherman','Horror','Slasher','halloween slasher','halloween slasher',true),
  F('Nosifer','Horror','Blood Chunky','blood monster','blood monster',true),
  F('Metal Mania','Horror','Metal','metal band','metal band',true),
  F('Eater','Horror','Melting','melting monster','melting monster'),
  F('Frijole','Horror','Cracked','cracked horror','cracked horror'),
  F('New Rocker','Horror','Rock Gothic','rock gothic','rock gothic'),
  F('Nightmare','Horror','Nightmare','nightmare horror','nightmare horror'),
  F('Pirata One','Gothic','Fraktur','pirate gothic','pirate gothic',true),
  F('Faster One','Display','Speed','speed racing','speed racing'),
  F('Rubik Wet Paint','Display','Wet','wet drip','wet drip'),
  F('Rye','Display','Western','western saloon','western saloon'),

  // ---- Gothic / Blackletter (12)
  F('UnifrakturCook','Gothic','Blackletter','blackletter medieval','blackletter medieval',true),
  F('UnifrakturMaguntia','Gothic','Old English','old english','old english',true),
  F('MedievalSharp','Gothic','Uncial','uncial medieval','uncial medieval',true),
  F('Pirata One','Gothic','Fraktur','fraktur pirate','fraktur pirate'),
  F('Cinzel','Serif','Roman Inscription','roman luxury','roman luxury'),
  F('Almendra','Gothic','Old Style Serif','medieval serif','medieval serif'),
  F('Metamorphous','Gothic','Fantasy','fantasy gothic','fantasy gothic'),
  F('Uncial Antiqua','Gothic','Uncial','celtic uncial','celtic uncial'),
  F('Trade Winds','Display','Tiki','tiki retro','tiki retro'),
  F('Berkshire Swash','Serif','Swash Retro','swash retro','swash retro'),
  F('Fondamento','Script','Calligraphic','calligraphic','calligraphic'),
  F('Astloch','Gothic','Blackletter','blackletter','blackletter'),

  // ---- Cute / Children
  F('Fredoka','Sans Serif','Rounded','rounded cute','rounded cute'),
  F('Chewy','Display','Bubble','bubble kids','bubble kids'),
  F('Baloo 2','Display','Rounded','rounded playful','rounded playful'),
  F('Comfortaa','Sans Serif','Rounded','rounded soft','rounded soft'),
  F('Patrick Hand','Handwritten','Casual','kid handwriting','kid handwriting'),
  F('Schoolbell','Handwritten','Kid','school kid','school kid'),
  F('Sniglet','Sans Serif','Rounded','rounded cute','rounded cute'),
  F('Coming Soon','Handwritten','Casual','handwritten fun','handwritten fun'),

  // ---- Luxury / Editorial / Deco / Nouveau
  F('Cormorant SC','Serif','Small Caps','luxury sc','luxury sc'),
  F('Marcellus SC','Serif','Small Caps','luxury sc','luxury sc'),
  F('Poiret One','Display','Art Deco','deco elegant','deco elegant'),
  F('Limelight','Display','Deco','deco headline','deco headline'),
  F('Della Respira','Display','Deco','deco vintage','deco vintage'),
  F('Bruno Ace','Display','Retro Futurism','retro futurism','retro futurism'),
  F('Sail','Script','Nouveau','nouveau elegant','nouveau elegant'),
  F('Art Nouveau Stamp','Display','Art Nouveau','nouveau stamp','nouveau stamp'),
  F('Bratsy Script','Script','Boutique','boutique signature','boutique signature'),
  F('Campione Neue Serif','Serif','Editorial','editorial luxury','editorial luxury'),
  F('Perandory Condensed','Sans Serif','Condensed','condensed luxury','condensed luxury'),
  F('Rondal','Sans Serif','Grotesque','modern editorial','modern editorial'),

  // ---- Decorative / Stencil / Comic / Typewriter / Pixel / Gaming
  F('Stardos Stencil','Stencil','Stencil Slab','stencil military','stencil military',true),
  F('Allerta Stencil','Stencil','Stencil Sans','stencil sans','stencil sans'),
  F('Big Shoulders Stencil','Stencil','Stencil Extended','stencil extended','stencil extended'),
  F('Freehand','Handwritten','Chalk','chalk board','chalk board'),
  F('Special Elite','Typewriter','Distressed Typewriter','typewriter vintage','typewriter vintage'),
  F('Cutive Mono','Typewriter','Typewriter Mono','typewriter mono','typewriter mono'),
  F('Courier Prime','Typewriter','Screenplay','screenplay typewriter','screenplay typewriter'),
  F('Press Start 2P','Pixel','8-bit','arcade 8-bit','arcade 8-bit'),
  F('VT323','Pixel','Terminal','terminal retro','terminal retro'),
  F('Silkscreen','Pixel','Pixel','pixel sign','pixel sign'),
  F('Handjet','Pixel','Pixel Variable','pixel variable','pixel variable'),
  F('Pixelify Sans','Pixel','Pixel Sans','pixel sans','pixel sans'),
  // ---- Final 31 to reach 250
  F('Neue Haas Grotesk','Sans Serif','Neo-Grotesque','iconic swiss','swiss iconic'),
  F('Helvetica Now','Sans Serif','Neo-Grotesque','swiss modern','swiss modern'),
  F('Recoleta Alt','Serif','Contemporary Serif','friendly editorial','friendly editorial'),
  F('GT America','Sans Serif','Grotesque','editorial swiss','editorial swiss'),
  F('GT Walsheim','Sans Serif','Geometric','geometric modern','geometric modern'),
  F('Söhne','Sans Serif','Neo-Grotesque','editorial swiss','editorial swiss'),
  F('Circular','Sans Serif','Geometric','geometric friendly','geometric friendly'),
  F('Gotham','Sans Serif','Geometric','iconic geometric','iconic geometric'),
  F('Proxima Nova','Sans Serif','Humanist','clean workhorse','workhorse clean'),
  F('Avenir','Sans Serif','Humanist Geometric','humanist geometric','humanist geometric'),
  F('Trade Gothic','Sans Serif','Grotesque','editorial condensed','editorial condensed'),
  F('Franklin Gothic','Sans Serif','Grotesque','american classic','american classic'),
  F('Sabon','Serif','Old Style','classical book','classical book'),
  F('Caslon','Serif','Old Style','classical british','classical british'),
  F('Garamond','Serif','Old Style','classical elegant','classical elegant'),
  F('Baskerville','Serif','Transitional','editorial classical','editorial classical'),
  F('Mrs Eaves','Serif','Transitional','elegant editorial','elegant editorial'),
  F('Freight','Serif','Transitional','editorial versatile','editorial versatile'),
  F('Tiempos','Serif','Transitional','editorial modern','editorial modern'),
  F('GT Sectra','Serif','Contemporary Serif','sharp editorial','sharp editorial'),
  F('Domaine Display','Serif','Didone','luxury editorial','luxury editorial'),
  F('Canela','Serif','Contemporary Serif','fashion luxury','fashion luxury'),
  F('Editor Serif','Serif','Didone','editorial luxury','editorial luxury'),
  F('Sang Bleu','Serif','Contemporary Serif','tattoo editorial','tattoo editorial'),
  F('Neue Machina','Display Sans','Techno','tech utility','tech utility'),
  F('Space Mono','Typewriter','Mono','mono tech','mono tech'),
  F('Departure Mono','Typewriter','Pixel Mono','pixel mono','pixel mono'),
  F('Millimetre','Display','Wireframe','wireframe experimental','wireframe experimental'),
  F('PP Editorial New','Serif','Editorial','editorial modern','editorial modern'),
  F('PP Neue Montreal','Sans Serif','Neo-Grotesque','swiss modern','swiss modern'),
  F('PP Hatton','Serif','Contemporary Serif','fashion luxury','fashion luxury'),
  F('Boska','Serif','Didone Alt','fashion editorial','fashion editorial'),
];

// Legally embeddable subset (mirrors fontMap.js when name matches an already-loaded family).
export const FONT_FAMILY_LIST = Array.from(new Set(FONT_DATABASE.map(f => f.classification || f.family)));
